import PageHeader from "@/components/shared/PageHeader";
import CTASection from "@/components/shared/CTASection";
import { PARTNERSHIPS } from "@/data/content";

export default function Partnerships() {
  return (
    <>
      <PageHeader
        overline="Global Partnerships and Peak Bodies"
        title="The institutions whose work the Centre tracks, translates, and convenes around."
        lead="A directory of the international institutions whose frameworks, standards, and initiatives the Centre references. Presence on this page does not imply endorsement."
      />

      <section className="ccdr-section">
        <div className="ccdr-container">
          <div className="ccdr-callout mb-12 max-w-3xl">
            <p className="ccdr-prose">
              <strong>A note on independence.</strong>{" "}
              The Centre references these bodies as authoritative sources and convenes dialogue around their work.
              Presence here indicates that the Centre tracks and translates an institution&apos;s output — not that the
              institution endorses the Centre.
            </p>
          </div>

          <div className="space-y-16">
            {PARTNERSHIPS.map((group) => (
              <div key={group.group}>
                <p className="ccdr-eyebrow mb-6">{group.group}</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#E5E7EB] border border-[#E5E7EB]">
                  {group.members.map((m) => (
                    <div key={m.name} className="bg-white p-8">
                      <h3 className="ccdr-h3 mb-3">{m.name}</h3>
                      <p className="text-[#4B5563] leading-relaxed">{m.body}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Explore an institution's work through the Frameworks and Standards hub, or propose a partnership."
        primary={{ to: "/get-involved", label: "Propose a partnership" }}
        secondary={{ to: "/frameworks", label: "Or open the library" }}
      />
    </>
  );
}
